import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import ContactCard from './ContactCard';
import { STAGE_ZONE } from '@/lib/constants';

export default function KanbanColumn({ stage, contacts, agents }) {
    const { isOver, setNodeRef } = useDroppable({ id: stage });
    const zone = STAGE_ZONE[stage] || 'prospects';
    return (
        <div ref={setNodeRef} data-zone={zone} className={`aks-kanban-col ${isOver ? 'aks-drop-target' : ''}`} data-testid={`kanban-col-${stage}`}>
            <div className="flex items-center justify-between mb-2.5 px-1">
                <div className="flex items-center gap-2">
                    <span className="text-[12px] font-semibold uppercase tracking-wider text-aks-navy">{stage}</span>
                    <span className="text-[11px] font-medium text-gray-500 px-1.5 py-0.5 rounded bg-white border border-gray-200">{contacts.length}</span>
                </div>
            </div>
            <div className="space-y-2">
                {contacts.length === 0 ? (
                    <div className="py-6 text-center text-[11px] text-gray-400">Drop here</div>
                ) : contacts.map((c) => (
                    <ContactCard key={c.id} contact={c} agents={agents} />
                ))}
            </div>
        </div>
    );
}
